/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit';

/**
 * Divider CSS
 */
export const styles = css`
	:host {
		display: block;
		height: 100%;
	-webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
	}

	.divider {
		background-color: var(--nile-colors-neutral-400 , var(--ng-colors-border-secondary));
		display: flex;
    	align-items: center;
    	justify-content: center;
	}
	
	.horizontal {
		height: var(--nile-radius-radius-xxs , var(--ng-stroke-width-1));
		/* width: 100%; */
		margin: 8px 0;
	}

	.vertical {
		height: 100%;
		width: var(--nile-radius-radius-xxs , var(--ng-stroke-width-1));
		margin: 0 8px;
		/* display: inline-block;
		vertical-align: middle; */
	}

	.inset.horizontal {
		margin-left: 72px;
	}
	.background-white{
		background: var(--nile-colors-white-base , var(--ng-colors-fg-white));
		font-family: var(--nile-font-family-sans-serif, var(--ng-font-family-body));
		font-size: var(--nile-type-scale-5 , var(--ng-font-size-text-lg));
		font-weight: var(--nile-hero-text-font-weight , var(--ng-font-weight-semibold)) ;
		max-width: var(--nile-sizes-width-xxs , var(--ng-spacing-80));
		text-overflow: ellipsis;
	}
	.horizontal-content-padding{
		padding: var(--nile-spacing-spacing-none , var(--ng-spacing-none)) var(--nile-type-scale-2 , var(--ng-spacing-md));
		overflow: auto;
	}
	.vertical-content-padding{
		padding: var(--nile-type-scale-2 , var(--ng-spacing-md)) var(--nile-spacing-spacing-none , var(--ng-spacing-none))
	}

`;

export default [styles];